/*
---
description: FED Process
authors:
- David Chan CK
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var Site = new Class({
	initialize: function(){
		var bdy = document.id(document.body),
				id = bdy.get('id'), 
				page;

		id = Core.id_to_page(id);

		eval('page = typeOf(' + id + ')');

		if(page == 'class'){
			eval('page = new ' + id + '()');
			this.page = page;
		}else{
			this.page = new Page();
		}

		// Track External Links
		crTracker.trackClickEvent();
		// handle skip to content
		Core.handleSkipToContent();

		Core.init_cookie_notice();
	},


	get_page: function(){
		return this.page;
	}
});
